import React from 'react';
import classes from './ColorRow.module.css';
import { colors } from 'shared/utility';

export const colorRow = (props) => {
  const indexArray = [...Array(props.length)].map((v, i) => i + props.startIndex);
  return (
    <div className={classes.RowContainer}>
      {indexArray.map((i) => {
        const color = colors[i];
        const isSelected = props.selectedColor && props.selectedColor === color.name;
        return (
          <span
            key={color.name}
            style={{ backgroundColor: isSelected ? '#fff' : color.rgb, border: `4px solid ${color.rgb}` }}
            className={props.color === colors[0].name ? [classes.Color, classes.Selected].join(' ') : classes.Color}
            onClick={() => props.handleColorSelection(color.name)}
          />
        );
      })}
    </div>
  );
};

export default colorRow;
